import { render, staticRenderFns } from "./ScreenTabPendingEmptyState.vue?vue&type=template&id=391abad4&"
import script from "./ScreenTabPendingEmptyState.vue?vue&type=script&lang=js&"
export * from "./ScreenTabPendingEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports